export const isEmpty = (string?: unknown): boolean => string === null || string === undefined || `${string}`.trim() === "";

/** Converts the first character of the string to uppercase */
export const capitalize = (string?: string): string | undefined => (string ? string.charAt(0).toUpperCase() + string.slice(1) : undefined);

/** Converts the first character of the string to lowercase */
export const toCamelCase = (string?: string): string | undefined => (string ? string.charAt(0).toLowerCase() + string.slice(1) : undefined);
